module.exports = __webpack_public_path__ + "static/media/video.67983692.jpg";